import { render, staticRenderFns } from "./ProjectChooseStartEndReadOnlyView.vue?vue&type=template&id=2dc99a6b&scoped=true&"
import script from "./ProjectChooseStartEndReadOnlyView.vue?vue&type=script&lang=js&"
export * from "./ProjectChooseStartEndReadOnlyView.vue?vue&type=script&lang=js&"
import style0 from "./ProjectChooseStartEndReadOnlyView.vue?vue&type=style&index=0&id=2dc99a6b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc99a6b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib'
installComponents(component, {VFlex})
